import { handleActions } from 'redux-actions';
import actions from '../actions';

const { update, reset } = actions.user;

const defaultState = {};

export default handleActions(
  {
    [update]: (state, { payload }) => payload,
    [reset]: () => defaultState,
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/reducers/user.js